var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    !_vm.isExcluded &&
    !_vm.currentUser.isLtd &&
    !_vm.currentUser.hasActiveCbSubscription &&
    _vm.currentUser.userTrialStatus == 'active'
  )?_c('div',{staticClass:"\n    notice-bar\n    bg-secondary-dark\n    text-center text-primary\n    flex\n    items-center\n    justify-center\n  "},[_c('span',{staticClass:"mr-4 text-white"},[_vm._v("You have "+_vm._s(_vm.currentUser.userTrialDaysLeft)+" days left in your trial")]),_c('Button',{attrs:{"variant":"basic","color":"primary","size":"small"},on:{"click":function($event){return _vm.$router.push('/plans')}}},[_vm._v(" Buy Converdy ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }